export default __webpack_public_path__ + "static/PES1-c7f1837cb5dd606085975cc4cf720737.jpg";